module.exports = __webpack_public_path__ + "img/icon-audio-stop.e5eb3a2d.png";